import * as axios from 'axios'

export function leftPad(n, width, z) {
  z = z || '0'
  n = n + ''
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
}

// sprintDate takes an arbitrary date string as input (should be Universal
// Sortable, though) and returns it formatted as "YYYY-MM-DD HH:MM UTC".
export function sprintDate(dateStr) {
  let d = new Date(dateStr)

  return leftPad(d.getUTCFullYear(), 4) +
  '-' + leftPad(d.getUTCMonth()+1, 2) +
  '-' + leftPad(d.getUTCDate(), 2) +
  ' ' + leftPad(d.getUTCHours(), 2) +
  ':' + leftPad(d.getUTCMinutes(), 2) +
  ' UTC'
}

// sprintPercent takes a [0, 1] probability as input and returns it formatted as
// a percentage, with one decimal.
export function sprintPercent(p) {
  return (p*100).toFixed(1) + '%'
}

// sprintSmallPercent takes a [0, 1] probability as input and returns it
// formatted as a percented, rounded to the nearest integer.
export function sprintSmallPercent(p) {
  return Math.round(p*100) + '%'
}

// sprintDuration takes a duration in nanoseconds as input, converts it to a
// human-understandable unit, and return this along with the unit symbol.
export function sprintDuration(d) {
  if (d < 1e+6) { // Less than a millisecond, show in microseconds.
    return Math.round(d/1e+3) + 'μs'
  } else if (d < 1e+9) { // Less than a second, show in milliseconds.
    return Math.round(d/1e+6) + 'ms'
  } // Show in seconds.
  return Math.round(d/1e+9).toFixed(1) + 's'
}

// loadData asynchronously fetches data from the backend corresponding to tag.
// It is meant to be used in beforeRouteEnter lifecycle hooks, so `next` is the
// the same parameter as it is there.
//
// Consumers will need to implement a setData(err, data) method which is called
// with the result from the backend.
export function loadData(tag, next) {
  if (global.preload[tag]) {
    next(vm => vm.setData(null, global.preload[tag]))
    return
  }

  let loadingBarBg = document.getElementById('loading-bg'),
    loadingBar = document.getElementById('loading-bar')
  if (loadingBarBg) {
    loadingBarBg.classList.add('bg-sky')
  }
  if (loadingBar) {
    loadingBar.classList.add('active')
  }

  axios.get('/data'+tag, {timeout: 10000}).then(function(resp) {
    if (loadingBarBg) {
      loadingBarBg.classList.remove('bg-sky')
    }
    if (loadingBar) {
      loadingBar.classList.remove('active')
    }
    global.preload[tag] = resp.data
    next(vm => vm.setData(null, resp.data))
  }).catch(function(err) {
    if (loadingBar) {
      loadingBar.classList.remove('active')
    }
    next(vm => vm.setData(err, null))
  })
}

export default {
  methods: {
    leftPad: leftPad,
    sprintDate: sprintDate,
    sprintPercent: sprintPercent,
    sprintSmallPercent: sprintSmallPercent,
    sprintDuration: sprintDuration,
  },
}



// WEBPACK FOOTER //
// ./src/components/mixins/util.js